import React from 'react';
import PropTypes from 'prop-types';
import { Prompt } from 'react-router-dom';
import AccountSettingsDisplay from './AccountSettingsDisplay';

function checkCarrierAccounts(accounts) {
  const errors = [];
  let areErrors = false;
  if (accounts != null) {
    accounts.forEach((account, index) => {
      const adjustedNumber = account.replace(/_/g, '').trim();
      if (adjustedNumber.length !== 9) {
        errors[index] = 'FedEx account numbers must be 9 digits, all numbers.';
        areErrors = true;
      } else {
        errors[index] = undefined;
      }
    });
  }
  if (areErrors) {
    return errors;
  }
  return null;
}

function zipCodeIsValid(zipCode) {
  if (zipCode == null) {
    return true;
  }
  const adjustedZip = zipCode.replace(/_/g, '').trim();
  if (adjustedZip.length < 5) {
    return false;
  }
  return true;
}

class AccountSettingsContainer extends React.Component {
  static propTypes = {
    loadAccount: PropTypes.func.isRequired,
    saveAccount: PropTypes.func.isRequired,
    postAccountReset: PropTypes.func.isRequired
  };

  state = {
    account: {
      LegalName: undefined,
      FBPN: undefined,
      Carrier: undefined,
      CarrierAccounts: undefined,
      TradeName: undefined,
      Email: undefined,
      AddressLine: undefined,
      PhoneNumber: undefined,
      City: undefined,
      State: undefined,
      ZipCode: undefined
    },
    errors: {
      LegalName: undefined,
      FBPN: undefined,
      Carrier: undefined,
      CarrierAccounts: undefined,
      TradeName: undefined,
      Email: undefined,
      AddressLine: undefined,
      PhoneNumber: undefined,
      City: undefined,
      State: undefined,
      ZipCode: undefined
    },
    isDirty: false,
  };

  componentWillMount() {
    this.props.loadAccount();
  }

  componentDidUpdate(prevProps) {
    if (this.props.carrierAccount && this.props.carrierAccount !== prevProps.carrierAccount) {
      const account = this.props.carrierAccount;
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ account });
    }
    if (this.props.posting !== prevProps.posting && this.props.posting === false && this.props.error === false) {
      this.props.postAccountReset();
    }
    if (this.props.posting !== prevProps.posting && this.props.posting === undefined && this.props.error === false) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ isDirty: false }, () => this.props.loadAccount());
    }
  }

  handleOnChange = (newValue) => {
    let adjustedNewValue;
    if (newValue.state !== undefined) {
      adjustedNewValue = { ...newValue, State: newValue.State.toUpperCase() };
    } else {
      adjustedNewValue = newValue;
    }
    if (this.state.isDirty === false) {
      this.setState({ account: adjustedNewValue, isDirty: true });
    } else {
      this.setState({ account: adjustedNewValue });
    }
  }

  handleSubmit = () => {
    const errors = this.validateForm();
    if (errors === null) {
      this.props.saveAccount(this.state.account);
    } else {
      this.setState({ errors });
    }
  }

  clearErrors = () => {
    const errors = {
      Name: undefined,
      FBPN: undefined,
      Carrier: undefined,
      CarrierAccounts: undefined,
      TradeName: undefined,
      Email: undefined,
      AddressLine: undefined,
      PhoneNumber: undefined,
      City: undefined,
      State: undefined,
      ZipCode: undefined
    };
    this.setState({ errors });
  }

  validateForm = () => {
    this.clearErrors();
    const { account } = this.state;
    const errors = {};

    if (account.LegalName == null) {
      errors.LegalName = 'Please enter a legal name';
    }

    if (account.FBPN == null) {
      errors.FBPN = 'Please enter an FBPN';
    }

    const carrierAccountsErrors = checkCarrierAccounts(account.CarrierAccounts);
    if (carrierAccountsErrors != null) {
      errors.CarrierAccounts = carrierAccountsErrors;
    }

    if (!zipCodeIsValid(account.ZipCode)) {
      errors.ZipCode = 'Zip Codes must be at least 5 digits';
    }

    if (Object.keys(errors).length !== 0) {
      return errors;
    }
    return null;
  }

  render() {
    const { carrierAccount } = this.props;
    const isProducer = carrierAccount != null ? carrierAccount.IsProducer : undefined;
    return (
      <div>
        { carrierAccount && (
          <AccountSettingsDisplay
            { ...this.props }
            errors={ this.state.errors }
            value={ this.state.account }
            onChange={ this.handleOnChange }
            onSubmit={ this.handleSubmit }
            isDirty={ this.state.isDirty }
            isProducer={ isProducer }
          />
        ) }
        <Prompt
          when={ this.state.isDirty }
          message="You have unsaved changes. Are you sure you wish to navigate away?"
        />
      </div>
    );
  }
}

export default AccountSettingsContainer;
